import styles from "./TaskDetail.module.scss";

/** A label and value pair in the task's Details grid. */
export const TaskDetailRow = ({
    label,
    children,
}: {
    label: string;
    children: React.ReactNode;
}) => (
    <>
        <div className={styles.detailLabel}>
            <span>{label}</span>
        </div>
        <div className={styles.detailField}>{children}</div>
    </>
);
